import { render, staticRenderFns } from "./CustomStylesEditor.vue?vue&type=template&id=dfa924a8&scoped=true&"
import script from "./CustomStylesEditor.vue?vue&type=script&lang=js&"
export * from "./CustomStylesEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomStylesEditor.vue?vue&type=style&index=0&id=dfa924a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa924a8",
  null
  
)

export default component.exports